import { CardSet } from "../../models/cards/cardSet";

export class EmptySet implements CardSet {
    set_name: string = '';
    set_code: string = '';
    set_rarity: string = '';
    set_rarity_code: string = '';
    set_price: string = '';
}